<template>
  <div class="sd">
    <a-menu
      mode="inline"
      :open-keys="openKeys"
      :selected-keys="curroute"
      style="width: 100%;"
      :default-keys="['buddy']"
      @openChange="onOpenChange"
    >
      <a-sub-menu key="buddy">
        <span slot="title">
          <span>Buddy System</span>
        </span>
        <!-- <a-menu-item class="meeting-link" key="/user/meeting">
          <router-link to="/user/meeting">My Meetings</router-link>
        </a-menu-item> -->
         <!-- <a-menu-item class="task-link" key="/user/task">
          <router-link to="/user/task">My Tasks</router-link>
        </a-menu-item> -->
        <a-menu-item class="home-link" key="/user/home">
          <router-link to="/user/home">Current Status</router-link>
        </a-menu-item>
      </a-sub-menu>
    </a-menu>
    <a-button @click="logout">Logout</a-button>
  </div>
</template>
<script>
import { mapActions } from "vuex";
export default {
  data() {
    return {
      rootSubmenuKeys: ['sub1', 'sub2', 'sub4'],
      openKeys: ['buddy'],
    }
  },
  computed: {
    curroute() {
      return [this.$route.path]
    },
  },
  methods: {
    onOpenChange(openKeys) {
      const latestOpenKey = openKeys.find((key) => !this.openKeys.includes(key))
      if (!this.rootSubmenuKeys.includes(latestOpenKey)) {
        this.openKeys = openKeys
      } else {
        this.openKeys = latestOpenKey ? [latestOpenKey] : []
      }
    },
    logout(){
      this.quit()
      this.$router.replace("/")
    },
    ...mapActions({
      quit: "user/logout",
    }),
  },
}
</script>

<style lang="less" scoped>
.sd {
  width: 100%;
  height: 100%;
  border-right: 1px solid #e8e8e8;
}
.ant-menu-item-selected {
  background: #f1c331;
  a {
    color: black;
    font-weight: 600;
    font-size: 1rem;
  }
}
.ant-menu-submenu-title {
  span {
    font-size: 1.5rem;
    overflow: auto;
    outline: black;
  }
}
  a:focus {
    outline: black !important;
  }
.ant-menu-item:focus {
    border: 1px solid !important ;

}
</style>
